<script>
  // The job the solver is running right now.
  import { onMount, onDestroy } from "svelte";
  import JobCard from "../UI/JobCard.svelte";
  import IconButton from "../UI/IconButton.svelte";
  import LogPanel from "../UI/LogPanel.svelte";
  import { download, killJob } from "../../lib/jobs.js";
  import { getSocket } from "../../lib/socket.js";

  export let fileId;
  export let filename;

  let solverFeedback = "";

  // Shares the page's one connection rather than opening its own. The socket
  // is owned by QueueFiles, which is the only thing that renders this card, so
  // disconnecting is its job -- doing it here would kill the poll as well.
  const socket = getSocket();

  function onFeedback(data) {
    solverFeedback += data;
  }

  onMount(() => socket.on("solverFeedback", onFeedback));
  onDestroy(() => socket.off("solverFeedback", onFeedback));
</script>

<JobCard id={fileId} title={filename} status="busy" live>
  <svelte:fragment slot="actions">
    <IconButton
      tip="Download input python file"
      icon="fa-code"
      colour="warning"
      onClick={() => download.python(fileId)}
    />
    <IconButton
      tip="Download input excel file"
      icon="fa-file-excel"
      colour="success"
      onClick={() => download.inputExcel(fileId)}
    />
    <IconButton
      tip="Kill solver"
      icon="fa-skull"
      colour="error"
      onClick={() => killJob(fileId)}
    />
  </svelte:fragment>

  <!-- Was a disabled <textarea> at width:75%; height:150px, with the scroll
       handling written inline. LogPanel does the auto-scroll, the scroll-lock
       and the copy button, and is shared with the sibling RIC BGO Tool. -->
  <LogPanel text={solverFeedback} label="Solver output" />
</JobCard>
